// meta-frentista-interno-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "% app do posto": "% app de la estación",
    "%{com} de %{total}": "%{com} de %{total}",
    "%{e} prazo vencido · %{c} viraram contrato": "%{e} plazo vencido · %{c} pasaron a contrato",
    "%{n} já ativaram": "%{n} ya activaron",
    "%{pct}% dos dias": "%{pct}% de los días",
    "%{p}% do que a equipe rende": "%{p}% de lo que rinde el equipo",
    "Abaixo na fidelização": "Por debajo en fidelización",
    "Aguardando resposta": "Esperando respuesta",
    "Ativado": "Activado",
    "Ativado em": "Activado el",
    "Aviso do dia 51": "Aviso del día 51",
    "Concluída": "Concluida",
    "Convite": "Invitación",
    "Convite de Meta de Frentista": "Invitación del Objetivo del Playero",
    "Convites": "Invitaciones",
    "Convites criados": "Invitaciones creadas",
    "Convites de Meta de Frentista": "Invitaciones del Objetivo del Playero",
    "Convites fechados": "Invitaciones cerradas",
    "Convites recalculados": "Invitaciones recalculadas",
    "Criado": "Creado",
    "Criado até": "Creado hasta",
    "Criado de": "Creado desde",
    "Criados": "Creados",
    "Custo (US$)": "Costo (US$)",
    "Dados insuficientes": "Datos insuficientes",
    "Em andamento": "En curso",
    "Em degustação": "En degustación",
    "Encerrado": "Finalizado",
    "Encerrados": "Finalizados",
    "Execuções semanais": "Ejecuciones semanales",
    "Execuções semanais da Meta de Frentista": "Ejecuciones semanales del Objetivo del Playero",
    "Fechado sozinho": "Cerrado solo",
    "Fechados sozinhos": "Cerrados solos",
    "Fim da degustação": "Fin de la degustación",
    "Frentistas elegíveis": "Playeros elegibles",
    "Gatilhos": "Disparadores",
    "Gerada em": "Generada el",
    "Gerando": "Generando",
    "Idioma": "Idioma",
    "Indisponível": "No disponible",
    "Leitura final": "Lectura final",
    "Leitura semanal": "Lectura semanal",
    "Leituras da IA": "Lecturas de la IA",
    "Meta de Frentista (interno)": "Objetivo del Playero (interno)",
    "Na cauda": "En la cola",
    "Nenhum posto analisado.": "Ninguna estación analizada.",
    "Nenhum posto excluído.": "Ninguna estación excluida.",
    "Nenhum quadro criado.": "Ningún tablero creado.",
    "Nenhuma leitura da IA para este convite.": "Ninguna lectura de la IA para esta invitación.",
    "Nível escolhido": "Nivel elegido",
    "Nível recomendado": "Nivel recomendado",
    "Opções": "Opciones",
    "Pediram para continuar": "Pidieron continuar",
    "Pediu para continuar": "Pidió continuar",
    "Período-base: %{ini} a %{fim}": "Período base: %{ini} a %{fim}",
    "Piloto": "Piloto",
    "Postos analisados": "Estaciones analizadas",
    "Postos com gatilho": "Estaciones con disparador",
    "Postos excluídos da análise": "Estaciones excluidas del análisis",
    "Pronta": "Lista",
    "Prévia": "Vista previa",
    "Quadros criados": "Tableros creados",
    "Redes avaliadas": "Redes evaluadas",
    "Redes com gatilho": "Redes con disparador",
    "Rendimento da cauda": "Rendimiento de la cola",
    "Semana": "Semana",
    "T1": "T1",
    "T1 · produtividade abaixo da equipe": "T1 · productividad por debajo del equipo",
    "T2": "T2",
    "T2 · fidelização abaixo da média": "T2 · fidelización por debajo del promedio",
    "Texto do convite": "Texto de la invitación",
    "Tipo de meta": "Tipo de meta",
    "Tipos de meta": "Tipos de meta",
    "Todas as redes, no período e lançamento filtrados": "Todas las redes, en el período y lanzamiento filtrados",
    "Visto em": "Visto el",
    "Visto pela primeira vez": "Visto por primera vez",
    "Vistos": "Vistos",
    "cartão compartilhado": "tarjeta compartida",
    "equipe pequena": "equipo pequeño",
    "posto sem concentrador/ids divergentes": "estación sin concentrador/ids divergentes",
    "pouca tag de frentista": "poca etiqueta de playero",
    "poucos abastecimentos": "pocos abastecimientos",
    "prazo vencido": "plazo vencido",
    "sugestão v%{v}": "sugerencia v%{v}",
    "virou contrato": "pasó a contrato",
    "Última semana avisada": "Última semana avisada",
};

export default catalogo;
